// Display label for a question's cognitive level. Internally the third level
// is still tagged "Higher-Order Thinking" (Zod enum / DB / Blacksmith cue);
// users only ever see "Application+".
export function levelLabel(level: string): string {
  return level === "Higher-Order Thinking" ? "Application+" : level;
}
